"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TypeIcon", {
  enumerable: true,
  get: function () {
    return _typeIcon.default;
  }
});
exports.StyledPortal = exports.ToastWrapper = exports.ToastContentStyle = exports.ToastStyle = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _message = _interopRequireDefault(require("../message/message.style"));

var _messageContent = _interopRequireDefault(require("../message/message-content/message-content.style"));

var _typeIcon = _interopRequireDefault(require("../message/type-icon/type-icon.style"));

var _iconButton = _interopRequireDefault(require("../icon-button/icon-button.style"));

var _portal = _interopRequireDefault(require("../portal/portal"));

var _base = _interopRequireDefault(require("../../style/themes/base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const StyledPortal = (0, _styledComponents.default)(_portal.default)`
  ${({
  theme
}) => (0, _styledComponents.css)`
    position: absolute;
    top: 0;

    z-index: ${theme.zIndex.notification};

    ${({
  isCenter
}) => isCenter && (0, _styledComponents.css)`
        margin-left: 50%;
        transform: translateX(-50%);
      `}
  `}
`;
exports.StyledPortal = StyledPortal;
StyledPortal.defaultProps = {
  theme: _base.default
};
const animationName = ".toast";
const ToastStyle = (0, _styledComponents.default)(_message.default)`
  ${({
  maxWidth,
  isCenter
}) => (0, _styledComponents.css)`
    box-shadow: 0 10px 30px 0 rgba(0, 20, 29, 0.1),
      0 30px 60px 0 rgba(0, 20, 29, 0.1);
    line-height: 22px;
    margin-top: 30px;
    max-width: ${!maxWidth ? "300px" : maxWidth};
    position: relative;
    margin-right: ${isCenter ? "auto" : "30px"};
  `}
 

  &${animationName}-appear,
  &${animationName}-enter {
    opacity: 0;
    transform: scale(0.5)};
  }

  &${animationName}-appear.toast-appear-active,
  &${animationName}-enter.toast-enter-active {
    opacity: 1;
    transform: ${({
  isCenter
}) => isCenter ? " scale(1) translateY(0)" : "scale(1)"};
    transition: all 300ms cubic-bezier(0.250, 0.250, 0.000, 1.500);
  }

  &${animationName}-exit.toast-exit-active {
    opacity: 0;
    margin-top: -40px;
    transition: all 150ms ease-out;
  }

  ${_iconButton.default} {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
  }
`;
exports.ToastStyle = ToastStyle;
const ToastContentStyle = (0, _styledComponents.default)(_messageContent.default)`
  padding: 8px 16px 8px 16px;

  ${({
  isDismiss
}) => isDismiss && (0, _styledComponents.css)`
      padding-right: 48px;
    `}
`;
exports.ToastContentStyle = ToastContentStyle;
const ToastWrapper = _styledComponents.default.div`
  ${({
  isCenter
}) => isCenter && (0, _styledComponents.css)`
      position: relative;
      width: auto;
      height: auto;
      justify-content: center;
      display: flex;
    `}
`;
exports.ToastWrapper = ToastWrapper;